import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Table, TableColumn, TableRow, Text } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import SupersearchResultHeader from 'Components/Supersearch/SupersearchResultHeader';
import { fetchRecentLookups, type RecentLookup } from 'App/shadcn/pages/ProspectingTools/Lookup/lookupApi';

type Props = {
	/** Opens the lookup, which answers from the stored one without paying again. */
	onPick: (query: string) => void;
};

/**
 * The user's own Lookups from the last 15 days, under "Latest companies" in an empty supersearch
 * (WEB-14049). Shown only when there are some.
 */
const SupersearchRecentLookups = ({ onPick }: Props) => {
	const { t } = useTranslation();
	const [lookups, setLookups] = useState<RecentLookup[]>([]);

	useEffect(() => {
		let cancelled = false;
		fetchRecentLookups()
			.then(found => {
				if (!cancelled) setLookups(found);
			})
			.catch((err: unknown) => console.error('[Supersearch] recent lookups failed', err));
		return () => {
			cancelled = true;
		};
	}, []);

	if (!lookups.length) return null;
	return (
		<div className="SupersearchRecentLookups">
			<SupersearchResultHeader title={t('prospectingTools.lookup.recent')} icon="search" />
			<Table>
				{lookups.map(lookup => (
					<TableRow key={lookup.query} onClick={() => onPick(lookup.query)}>
						<TableColumn>
							<Text size="sm" ellipsis>
								{lookup.label ?? lookup.query}
							</Text>
							{lookup.label ? (
								<Text size="sm" color="grey-10" ellipsis>
									{lookup.query}
								</Text>
							) : null}
						</TableColumn>
						<TableColumn align="right">
							<Text size="sm" color="grey-10">
								{moment(lookup.foundAt).format('L')}
							</Text>
						</TableColumn>
					</TableRow>
				))}
			</Table>
		</div>
	);
};

export default SupersearchRecentLookups;
